export const exists$Len = (opt$Len) => opt$Len && opt$Len.length;
